<template>
  <div class="content-wrap">
    <el-form :inline="true">
      <el-form-item label="练习时间">
        <el-date-picker
          v-model="queryDate"
          type="daterange"
          range-separator="~"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期" style="width: 260px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="淘金客">
        <tjkautocompleteall @callBack="updateTjkId" :tjkId="searchData.tjkId"></tjkautocompleteall>
      </el-form-item>
      <el-form-item label="扮演客户">
        <tjkautocompleteall @callBack="updateToTjkId" :teacherTjkId="searchData.toTjkId"></tjkautocompleteall>
      </el-form-item>
      <el-form-item
          label="最低分数"
          prop="minScore"
          :rules="[
            { type: 'number', message: '必须为数字值'}
          ]"
        >
          <el-input type="minScore" v-model.number="searchData.minScore" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
          label="最高分数"
          prop="maxScore"
          :rules="[
            { type: 'number', message: '必须为数字值'}
          ]"
        >
          <el-input type="maxScore" v-model.number="searchData.maxScore" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
        <el-button type="primary" @click="exportList">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border highlight-current-row style="width: 100%">
      <el-table-column prop="beginTime" label="练习时间" align="center" width="150"></el-table-column>
      <el-table-column prop="realName" label="客服" align="center" width="162">
           <template slot-scope="scope">
              {{ scope.row.realName }}（{{ scope.row.tjkNumber }}）
           </template>
      </el-table-column>
      <el-table-column prop="teacherName" label="扮演客户" align="center" width="162">
          <template slot-scope="scope">
            {{ scope.row.teacherName }}（{{ scope.row.teacherTjkNumber }}）
          </template>
      </el-table-column>
      <el-table-column label="练习结果" align="center">
        <el-table-column prop="baseScore" label="基本条件" align="center"></el-table-column>
        <el-table-column prop="skillScore" label="服务技巧" align="center"></el-table-column>
        <el-table-column prop="riteScore" label="服务礼仪" align="center"></el-table-column>
        <el-table-column prop="flowScore" label="服务流程" align="center"></el-table-column>
      </el-table-column>
      <el-table-column prop="gradeScore" label="分数" align="center"></el-table-column>
      <!--<el-table-column label="操作" align="center">
        <template slot-scope='scope'>
          <a class="link-text" :href="'/studyManage/voiceScene/eachRecordDetail?id='+scope.row.id" target="_blank">详情{{searchData.total}}</a>
        </template>
      </el-table-column>-->
    </el-table>

    <pagination :pages="searchData.pages" :pageNum="searchData.pageNum" @getData="getList"></pagination>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
export default {
  components: { pagination },
  data () {
    return {
      businessMajorId: this.$route.query.businessMajorId, //场景id
      searchData: {
        pageNum:1,
        pageSize:10,
        pages:0,
        tjkId: this.$route.query.tjkId,
        trainId: this.$route.query.trainId,
        toTjkId: null,
        minScore:'',
        maxScore:'',
        effectStatus: this.$route.query.effectStatus,
        callInterVal: this.$route.query.callInterVal,
        qcEffectStatus: this.$route.query.qcEffectStatus,
        goodStatus: null,
        qcStatus: null,
        callInterval: this.$route.query.callInterVal
      },
      queryDate:[this.getCurrentDate().monthStartDate, this.getCurrentDate().monthEndDate],//培训时间
      queryBeginTime:this.$route.query.beginTime,
      queryEndTime:this.$route.query.endTime,
      majorList: [],
      list:null
    }
  },
  mounted: function () {
    this.getList();
  },
  methods: {

    updateTjkId(val) {
      this.searchData.tjkId = val.id;
    },
    updateToTjkId(val) {
      this.searchData.toTjkId = val.id;
    },
    //点分页组件的数字/下一页，会回传pageNum过来，平时直接点查新，参数是event对象，所以需要isNAN判断
    getList(pageNum) {
      if(pageNum && isNaN(pageNum) == false){
          this.searchData.pageNum = pageNum;
      }
      var self = this;
      if(this.queryBeginTime && this.queryEndTime){
        this.queryDate = [];
        this.queryDate[0] = this.queryBeginTime;
        this.queryDate[1] = this.queryEndTime;
      }
      if(this.queryDate && this.queryDate.length==2){
        this.searchData.beginTime = this.queryDate[0];
        this.searchData.endTime   = this.queryDate[1];
      }else{
        this.searchData.beginTime = null;
        this.searchData.endTime   = null;
      }
      this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryExerciseRecordAll', this.searchData).then(response=> {
        var result = response.data;
        if(result.success) {
          self.searchData.pages = result.data.pages;
          self.list = result.data.list;
        }else {
          this.$alert(result.msg);
        }
      },response=> {
        this.$alert("网络繁忙，请稍后重试！");
      })
    },
    exportList() {
      window.open(API_ROOT.college + '/export/excel/exportVoiceEachExerciseRecordAll?' + this.urlEncode(this.searchData));
    }
  }
}
</script>



// WEBPACK FOOTER //
// ./src/page/train/record/eachExerciseRecord.vue